import script from "./IncomeBiweekly.vue?vue&type=script&lang=ts&setup=true"
export * from "./IncomeBiweekly.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__